import { render, staticRenderFns } from "./paperworkHome.vue?vue&type=template&id=0fd2929b&scoped=true"
import script from "./paperworkHome.vue?vue&type=script&lang=js"
export * from "./paperworkHome.vue?vue&type=script&lang=js"
import style0 from "./paperworkHome.vue?vue&type=style&index=0&id=0fd2929b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd2929b",
  null
  
)

export default component.exports